import { NgModule } from '@angular/core';
import { ImageUrlPipe } from '../pipes/image-url.pipe';
import { SafeHtmlPipe } from '../pipes/DomSanitizer.pipe';

@NgModule({
    imports: [ImageUrlPipe, SafeHtmlPipe],
    exports: [ImageUrlPipe, SafeHtmlPipe],   // ✅ ما زال يصدرها عشان باقي المشروع يستخدمها
})
export class SharedModule { }
